




















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LabelOperation from '@/components/label/labelOperation.vue';
import CommentList from '@/components/comment/commentList.vue';
import ModuleTodo from './moduleTodo.vue';
import { pubsub, CREATED_TODO_EVENT, DELETE_TODO_EVENT, UPDATE_TODO_EVENT, BATCH_CREATED_TODO_EVENT } from '@/utils/pubsub';
import { createLabelUrl } from '@/components/label/labelOperation';
import { createCommentUrl } from '@/components/comment/commentOperation';
import { moduleListInstance } from '@/model/ModuleListClass';
import DetailBox from '@/components/detailBox/detailBox.vue';
import { generateUUID } from '@/utils/other';

type ITodoInfo = ITodo.IResponse.ITodoInfo;
type IModuleInfo = IModule.IResponse.IModuleInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;
type IModuleTemplateParams = IModule.IRequest.IModuleTemplateParams;

let createdTodoEventToken = '';
let deletedTodoEventToken = '';
let updateTodoStatusEventToken = '';
let batchCreatedTodoEventToken = '';

@Component({
  components: {
    LabelOperation,
    CommentList,
    ModuleTodo,
    DetailBox,
  },
})
export default class ModuleDetail extends Vue {
  @Prop({default: false}) private spinning!: boolean;
  @Prop({required: true}) private module!: IModuleInfo;
  @Prop({default: false}) private isTemplate!: boolean;
  get moduleId(): string {
    if (this.module) {
      return this.module.id;
    } else {
      return '';
    }
  }
  get canEdit() {
    if (this.module) {
      return (!['Cancel', 'Completed', 'Closed'].includes(this.module.status)) && (this.module.todos.length === 0);
    }
    return false;
  }
  get labelUrl() {
    return createLabelUrl('Module', this.moduleId);
  }
  get commentUrl() {
    return createCommentUrl('Module', this.moduleId);
  }
  @Watch('moduleId', {immediate: true})
  private watchModuleId(moduleId: string) {
    if (moduleId) {
      this.requestModuleDetail();
    }
  }
  private created() {
    this.bindEvent();
  }
  private destroyed() {
    this.unBindEvent();
  }
  private bindEvent() {
    createdTodoEventToken = pubsub.subscribe(CREATED_TODO_EVENT, (message: string, data: ITodoInfo) => {
      moduleListInstance.unshiftToTodos(this.module, data);
    });
    deletedTodoEventToken = pubsub.subscribe(DELETE_TODO_EVENT, (message: string, data: ITodoInfo) => {
      moduleListInstance.deleteTodo(this.module, data);
    });
    updateTodoStatusEventToken = pubsub.subscribe(UPDATE_TODO_EVENT, (message: string, data: ITodoInfo) => {
      moduleListInstance.updateTodo(this.module, data);
    });
    batchCreatedTodoEventToken = pubsub.subscribe(BATCH_CREATED_TODO_EVENT, (message: string, moduleId: string) => {
      if (this.module.id === moduleId) {
        this.requestModuleDetail();
      }
    });
  }
  private unBindEvent() {
    pubsub.unsubscribe(createdTodoEventToken);
    pubsub.unsubscribe(deletedTodoEventToken);
    pubsub.unsubscribe(updateTodoStatusEventToken);
    pubsub.unsubscribe(batchCreatedTodoEventToken);
  }
  private requestModuleDetail() {
    this.$emit('refreshDetail', this.module);
  }
  private handleUpdateStatus(status: IModule.IModuleStatus) {
    let operation = '';
    switch (status) {
      case 'Completed':
        operation = this.$t('form.complete').toString();
        break;
      case 'Closed':
        operation = this.$t('form.close').toString();
        break;
      case 'Cancel':
        operation = this.$t('form.cancel').toString();
        break;
      default:
        break;
    }
    this.$confirm({
      title: this.$t('operation.confirmMsg', {
        operation,
      }).toString(),
      onOk: () => {
        this.updateStatus(status);
      },
    });
  }
  private updateStatus(status: IModule.IModuleStatus) {
    if (status === 'Cancel') {
      const msg = this.checkTodoStatus();
      if (msg) {
        this.$message.warning(msg);
        return;
      }
    }
    this.$emit('statusChange', {
      module: this.module,
      status,
    });
  }
  private checkTodoStatus() {
    let errorMsg = '';
    if (this.module) {
      for (const todo of this.module.todos) {
        if (!['Completed', 'Closed'].includes(todo.status)) {
          errorMsg = this.$t('module.cancelTips').toString();
          break;
        }
      }
    }
    return errorMsg;
  }
  private handleRemove() {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {
        operation: this.$t('form.delete'),
      }).toString(),
      onOk: () => {
        this.removeModule();
      },
    });
  }
  private editModule() {
    this.$emit('edit', this.module);
  }
  private removeModule() {
    this.$emit('delete', this.moduleId);
  }
  private handleCommentAdd(newComment: ICreateOrUpdateComment) {
    this.$emit('commentChange', {
      module: this.module,
      comment: newComment,
      type: 'ADD',
    });
  }
  private handleLabelChange(newLabels: ILabelInfo[]) {
    this.$emit('labelChange', { module: this.module, labels: newLabels });
  }
  private goRequirementPage(requirementId: string): void {
    this.$router.push({
      name: 'Requirement',
      params: {
        id: requirementId,
      },
    });
  }
  private goSolutionPage(solutionId: string) {
    this.$router.push({
      name: 'Solution',
      params: {
        id: solutionId,
      },
    });
  }
  private addTemplate() {
    const {title, projectId, projectName, id, manDay, todos, comment} = this.module;
    const templateData: IModuleTemplateParams = {
      id: generateUUID(),
      moduleId: null,
      projectId,
      projectName,
      comment: comment || '',
      templateContent: {
        title,
        active: true,
        manDay,
        status: 0,
        templateTodoList: todos.map((todo) => {
          const {typeId, typeName, description, settlementConfigurationId, settlementConfigurationName} = todo;
          return {
            typeId,
            typeName,
            title: todo.title,
            manDay: todo.manDay,
            description,
            status: 0,
            todoStatus: 'Processing',
            settlementConfigurationId,
            settlementConfigurationName,
          };
        }),
      },
    };
    this.$emit('templateSave', templateData);
  }
}
